import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import Layout from "../../../components/dashboard/Layout";
import AddLiveVideo from "../../../containers/admin/liveVideos/models/add-liveVideo";
import SearchBar from "../../../containers/admin/liveVideos/searchbar";
import LiveVideosTable from "../../../containers/admin/liveVideos/table";
import { getLiveVideosRequest } from "../../../modules/admin-modules/liveVideos/Actions";

const LiveVideos = () => {
  const dispatch = useDispatch();
  const [isAdd, setAdd] = useState(false);
  const [selectedData, setSelectedData] = useState({});
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    dispatch(getLiveVideosRequest());
  }, [dispatch]);

  return (
    <Layout>
      <SearchBar
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
        setSearchTerm={setSearchTerm}
      />
      <LiveVideosTable
        setAdd={setAdd}
        setSelectedData={setSelectedData}
        searchTerm={searchTerm}
      />
      <AddLiveVideo
        key={`live-video-${isAdd}-${selectedData?.id ?? "new"}`}
        isAdd={isAdd}
        data={selectedData}
        setSelectedData={setSelectedData}
      />
    </Layout>
  );
};

export default LiveVideos;
